import React from 'react'
import PropTypes from 'prop-types'
import { useAuth } from 'lib/auth'
import SignInNudge from '../../components/sign-in-nudge'
import ActionButton from '../action-button'
import ParticipantFields from './participant-fields'
import ContactFields from './contact-fields'
import MarketingOptInCard from './marketing-opt-in-card'
import useStyles from './styles'

const PRIVACY_URL = 'https://www.pga.com/pga-of-america/privacy-policy'
const TERMS_URL = 'https://www.pga.com/pga-of-america/terms-of-service'

const ParticipantsStep = ({
  groupEvent,
  marketingOptInChecked,
  handleMarketingOptInChange,
  paymentRequired,
  steps,
  activeStep,
  handleNext,
}) => {
  const classes = useStyles()
  const { user, isConsumer } = useAuth()
  const userIsNotOptedIn = !user?.marketingOptInAt
  const isAuthenticatedConsumer = user && isConsumer

  return (
    <div className={classes.card}>
      <div className={classes.nudge}>
        <SignInNudge
          callout
          className={classes.nudgeCallout}
          iconClassName={classes.nudgeIcon}
        />
      </div>
      <ParticipantFields tags={groupEvent?.tags} />
      <ContactFields />
      {userIsNotOptedIn && (
        <MarketingOptInCard
          checked={marketingOptInChecked}
          onChange={handleMarketingOptInChange}
        />
      )}
      <div className={classes.footer}>
        {!isAuthenticatedConsumer ? (
          <p className={classes.legal}>
            By continuing you agree to PGA of America&apos;s{' '}
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>{' '}
            and{' '}
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>
            .
          </p>
        ) : (
          <span />
        )}
        <ActionButton
          groupEvent={groupEvent}
          paymentRequired={paymentRequired}
          steps={steps}
          activeStep={activeStep}
          className={classes.primaryButton}
          reviewLabel="Continue to review"
          onClick={() =>
            handleNext({ fieldsToValidate: ['participants', 'contact'] })
          }
        />
      </div>
    </div>
  )
}

ParticipantsStep.propTypes = {
  groupEvent: PropTypes.object.isRequired,
  marketingOptInChecked: PropTypes.bool,
  handleMarketingOptInChange: PropTypes.func,
  paymentRequired: PropTypes.bool,
  steps: PropTypes.array.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleNext: PropTypes.func.isRequired,
}

export default ParticipantsStep
